import React from "react";
import PlayerChart from "../PlayerChart/PlayerChart";

import { timezone_mapper_gmt } from "../../../../utils/timezoneMapper_gmt";
import { API_CONSTANTS } from "../../../../utils/constantInformation";
import { sportPositionMapping } from "../../../../utils/sportsConfig";
import {
  findSportByLeague,
  getCurrentSeasonForLeagueFromRC,
} from "../../../../utils/utils";
function Summary(props) {
  const player_season_stats = props.player_season_stats;
  const player_actual_season_stats = props.player_actual_season_stats;

  const [season_long_stats_value, setSesaonLongStats] = React.useState([]);
  const [statsType, setStatsType] = React.useState([]);
  const [datetime, setDateTime] = React.useState(null);
  React.useEffect(
    (async) => {
      document.title = "Player Summary";
      if (props.league !== undefined && props.league !== null) {
        const sport = findSportByLeague(
          props.league,
          props.rcConfig,
          "summary useeffect"
        );
        console.log(
          "League:",
          props.league,
          "Sport ",
          sport,
          "position ",
          props.player_position,
          "player actual season stats",
          player_actual_season_stats
        );
        const setStats = sportPositionMapping[sport][props.player_position];
        console.log("setStats", setStats, player_actual_season_stats);
        setStatsType(setStats);

        let season_long_actual_stats = [];

        for (
          var i = 0;
          i < setStats.length && player_season_stats.length > 0;
          i++
        ) {
          let actual_name;
          if (setStats[i]["actual_name"] == "Dream11ProjectedFantasyPoints") {
            actual_name = "Dream11ActualFantasyPoints";
          } else {
            actual_name = setStats[i]["actual_name"];
          }

          // changing `null` to -999 to have a generic numeric null constant
          let stat_value = player_actual_season_stats
            .map((val) => val[actual_name])
            .reduce(
              (acc, val) =>
                parseFloat(acc) +
                parseFloat(
                  JSON.parse(val) === API_CONSTANTS.NUMERIC_CONSTANT ? 0 : val
                ),
              0
            );
          
            stat_value = parseFloat(stat_value.toFixed(2));
          if (typeof stat_value == "undefined") {
            stat_value = "NA";
          }
          if (setStats[i]["display_name"] == "FP") {
            season_long_actual_stats.push({
              display_name: "TFP",
              value: stat_value,
            });
          } else {
            season_long_actual_stats.push({
              display_name: setStats[i]["display_name"],
              value: stat_value,
            });
          }
        }

        setSesaonLongStats(season_long_actual_stats);

        const date = new Date(
          props.player_stats["Date"] +
          "T" +
          props.player_stats["GameTime"] +
          ":00.000+" +
          timezone_mapper_gmt[props.player_stats["GameCountry"]]
        );
        let datetimestring =
          date.toDateString().split(" ")[0] +
          " " +
          date.getDate() +
          "/" +
          (date.getMonth() + 1);
        setDateTime(datetimestring);
      }
    },
    [props.player_actual_season_stats]
  );

  return (
    <>
      <div className="d-flex flex-column justify-content-center p-2 bg-dark">
        <div className="container align-items-center align-self-center m-1 bg-secondary">
          {player_season_stats.length > 0 ? (
            <PlayerChart player_stats={player_season_stats} />
          ) : (
            <div>
              <p className="justify-content-center text-center pt-3 text-white">
                No Data Available
              </p>
            </div>
          )}
        </div>
        <div className="container align-items-center align-self-center m-1 pt-3 bg-secondary">
          <h5>
            <b className="text-white">
              Projections vs {props.player_stats["Opponent"]}{" "}
            </b>
            <span>
              <small>{datetime}</small>
            </span>
          </h5>
          <div className="table-responsive">
            <table className="table">
              <tr>
                {statsType.map((stats, index) => (
                  <td key={index} className="text-center">
                    <b className="text-truncate">
                      {stats.display_name == "FP" ? "PFP" : stats.display_name}
                    </b>
                    <p className="text-truncate">
                      {props.player_stats[stats.actual_name] ==
                        API_CONSTANTS.NUMERIC_CONSTANT // TODO: @manthansolanki Handled -999 as Null value to show '--'
                        ? "--"
                        : props.player_stats[stats.actual_name]}
                    </p>
                  </td>
                ))}
              </tr>
            </table>
          </div>
        </div>
        <div className="container align-items-center align-self-center m-1 pt-3 bg-secondary">
          <h5>
            <b className="text-white">
              {getCurrentSeasonForLeagueFromRC(props.league, props.rcConfig)}{" "}
              Season Stats{" "}
            </b>

            <span>
              <small>
                (
                {player_actual_season_stats
                  ? player_actual_season_stats.length
                  : 0}{" "}
                Games)
              </small>
            </span>
          </h5>
          <div className="table-responsive">
            <table className="table">
              <tbody>
                {player_actual_season_stats.length > 0 ? (
                  <tr>
                    {season_long_stats_value.map((stats, index) => (
                      <td key={index} className="text-center">
                        <b className="text-truncate">{stats.display_name}</b>
                        <p className="text-truncate">{stats.value}</p>
                      </td>
                    ))}
                  </tr>
                ) : (
                  <div>
                    <p className="justify-content-center text-center pt-3 text-white">
                      No Data Available
                    </p>
                  </div>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default Summary;
